import { useEffect, useState } from 'react';
import { Comment } from '../types';
import { subscribeToComments } from '../services/comments';

export function useComments(projectId: string | null, fileId: string | null) {
  const [comments, setComments] = useState<Comment[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!projectId || !fileId) {
      setComments([]);
      return;
    }

    setLoading(true);
    const unsubscribe = subscribeToComments(projectId, fileId, (next) => {
      setComments(next.filter((comment) => !comment.resolved));
      setLoading(false);
    });

    return () => unsubscribe();
  }, [projectId, fileId]);

  return { comments, loading };
}
